import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { scheduledChangesQueryOptions } from "@/app/billing/api/get-scheduled-changes";
import { subscriptionQueryOptions } from "@/app/billing/api/get-subscriptions";
import { BillingTabs } from "@/app/billing/billing-tabs";
import { capabilitiesQueryOptions } from "@/app/capabilities/api/get-capabilities";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing"
)({
  beforeLoad: async ({ context: { queryClient }, params }) => {
    const scope = {
      organizationId: params.organizationId,
      projectId: params.projectId,
    };
    const capabilities = await queryClient.ensureQueryData(
      capabilitiesQueryOptions(scope)
    );
    if (!capabilities.billing.enabled) {
      throw redirect({
        to: "/orgs/$organizationId/projects/$projectId/home",
        params,
      });
    }

    const organizationId = params.organizationId;

    queryClient.prefetchQuery(subscriptionQueryOptions({ organizationId }));
    queryClient.prefetchQuery(scheduledChangesQueryOptions({ organizationId }));
  },
  loader: () => ({
    crumb: "Billing",
  }),
  component: BillingLayout,
});

function BillingLayout() {
  return (
    <div className="flex flex-col gap-6">
      <BillingTabs />
      <div className="min-h-[calc(100vh-16rem)]">
        <Outlet />
      </div>
    </div>
  );
}
